<template>
  <section>
    <b-card>
      <template #header>
        <div class="d-flex align-items-center">
          <span class="text-primary">CRM </span>
          <b-breadcrumb class="ml-2">
            <b-breadcrumb-item>
              <feather-icon
                icon="HomeIcon"
                scale="1.25"
                shift-v="1.25"
              ></feather-icon>
            </b-breadcrumb-item>
            <b-breadcrumb-item active> Leads</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </template>


    <div class="mt-2">

        <b-row class="mt-2">
        <b-col md="9"> </b-col>

        <b-col md="3">
          <div class="d-flex align-items-center mb-2">
            <span class="mr-1">Cerca</span>
            <b-form-input type="text" v-model="filter" size="md" />
          </div>
        </b-col>
      </b-row>
        
        <b-table
        :fields="fields"
        :items="leads"
        :busy="loading"
        :filter="filter"
        :per-page="perPage"
        :current-page="currentPage"
        striped
        show-empty
        responsive
      >
        <template #table-busy>
          <div class="text-center text-primary-light my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Caricamento dati delle attività...</strong>
          </div>
        </template>

        <template #empty>
          <h5 class="text-primary-light text-center my-2">Non ci sono leads</h5>
        </template>

        <template #emptyfiltered>
          <h5 class="text-primary-light text-center my-2">Non sono stati trovati leads</h5>
        </template>

        <template #cell(nominativo_rag.sociale)="data">
            {{data.item.ragione_sociale}}
        </template>

        <template #cell(attività)>
          <feather-icon class="cursor-pointer mr-2" icon="EyeIcon" size="20" @click="$refs.activitiesListModal.open()" />
          <feather-icon class="cursor-pointer" icon="PlusIcon" size="20" />
        </template>

        <template #cell(opzioni)="data">
          <feather-icon class="cursor-pointer mr-2" icon="EyeIcon" size="20" @click="$router.push('/crm/leads/' + data.item.id)"/>
          <feather-icon class="cursor-pointer mr-2" icon="EditIcon" size="20" @click="$router.push('/crm/leads/edit/' + data.item.id)"/>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        align="right"
        size="sm"
        class="my-0"
      />

    </div>



    </b-card>

    <!-- Modali -->

    <activities-list-modal ref="activitiesListModal"></activities-list-modal>

  </section>
</template>

<script>

import { BRow, BCol, BBreadcrumb, BBreadcrumbItem, BCard, BTable, BPagination, BFormInput } from "bootstrap-vue";

import { ActivitiesListModal } from "@/components/modals";

import {Requests} from "@/api"

export default {
  components: {
    BRow,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BTable,
    BPagination,
    BFormInput,
    ActivitiesListModal,
  },

  data: () => ({

      fields: [
          {
              key: "creato_da",
              sortable: true,
          },
          {
              key: "assegnato_a",
              sortable: true,
          },
          {
              key: "nominativo_rag.sociale",
              sortable: true,
          },
          {
              key: "telefono",
              sortable: true,
          },
          {
              key: "mail",
              sortable: true,
          },
          {
              key: "sorgente",
              sortable: true,
          },
          {
              key: "attività",
              sortable: false,
          },
          {
              key: "opzioni",
              sortable: false,
          },
      ],

      leads: [],

      //Helpers

      loading: false,
      currentPage: 1,
      perPage: 15,
      filter: '',


  }),

  created() {
      this.getLeadsList();
  },

  methods: {
      async getLeadsList() {
          this.loading = true;

          try {
              const response = await Requests.getLeadsList();
              this.leads = response;
          } catch(err) {
              console.debug(err)
          }

          this.loading = false
      },
  }
}

</script>


